import { Box } from '@mui/material'
import { GridColDef, GridRowId } from '@mui/x-data-grid-premium'
import { useMemo } from 'react'
import {
  CapacityParameterDataType,
  CapacityParametersTableProps,
} from './Tables.types'
// Modal and helper imports removed - functionality moved to BaseTable toolbar
import { BaseTable } from 'Features/Table/BaseTable.view'

const numericalFields = ['workCentreCapacity']
const stringFields: string[] = []

export const CapacityParameterTable = ({
  data,
  isLoading,
  updateTableData,
  updateParametersData,
  isUploading,
}: CapacityParametersTableProps) => {
  // Modal state and handlers removed - bulk update now handled by BaseTable toolbar

  const columns: GridColDef[] = useMemo(
    () => [
      {
        headerName: 'Base source site code',
        field: 'baseSourceSiteCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Work centre code',
        field: 'workCentreCode',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Formatted date',
        field: 'formattedDate',
        flex: 1,
        type: 'string',
      },
      {
        headerName: 'Work centre capacity',
        field: 'workCentreCapacity',
        flex: 1,
        editable: true,
        type: 'number',
      },
      {
        headerName: 'Date key',
        field: 'dateKey',
        flex: 1,
        type: 'string',
        hide: true,
      },
    ],
    [data]
  )

  return (
    <>
      {/* Toolbar functionality moved to BaseTable */}

      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
        }}
      >
        <BaseTable
          data={data ?? []}
          columns={columns}
          isLoading={isLoading}
          updateTableData={updateTableData}
          uploadData={updateParametersData} // Pass upload function to BaseTable
          isUploading={isUploading}
          isSaving={false}
          checkBoxSelection={true}
          showTableToolBar={true}
          pinnedColumns={['baseSourceSiteCode', 'workCentreCode']}
          downloadFileName="CapacityParameters"
          initialState={{
            columns: {
              columnVisibilityModel: {
                // dateKey: false,
              },
            },
          }}
        />
      </Box>
    </>
  )
}
